import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgSingle = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      d="M20 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M19.097 12.533a3.02 3.02 0 1 0 6.006 0l.994-.106a4.02 4.02 0 1 1-7.994 0z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M20 18a6 6 0 0 1 6 6v10H14V24a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="m20.25 19.75-2 8 2 2 2-2z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m22.066 29.017-1.871-7.476.97-.242 2.009 8.024-2.2 2.2-.708-.707z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgSingle);

export default ForwardRef;
